import {combineReducers} from 'redux';
import create from './create/reducer';
import approval from './workflow/reducer';
import driverAllocation from '../relocations/driver/reducer';

import vehicleRelocation from '../relocations/vehicle/reducer';

const corporateQuote = combineReducers({
  create,
  approval
});

export default corporateQuote;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/reducer.js